import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Section, Eyebrow, FadeIn } from "../../components/public/Section";
import { PageHero } from "./About";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/testimonials").then(r => setItems(r.data)); }, []);
  return (
    <>
      <PageHero title="Whispers from Our Patrons" subtitle="Hospitality is felt — here is what our patrons remember." image="https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Reviews</Eyebrow>
        <div className="grid md:grid-cols-2 gap-6 mt-8">
          {items.map((t, i) => (
            <FadeIn key={t.id} delay={i * 0.06}>
              <div className="bg-white border border-gold/20 p-9 h-full" data-testid={`testimonial-${i}`}>
                <Quote size={28} className="text-gold" />
                <div className="flex gap-1 text-gold my-4">
                  {[...Array(t.rating || 5)].map((_, j) => <Star key={j} size={14} fill="currentColor" />)}
                </div>
                <p className="serif italic text-xl leading-relaxed">"{t.quote}"</p>
                <div className="mt-6 border-t border-gold/15 pt-4">
                  <div className="serif text-lg">{t.name}</div>
                  <div className="text-navy-900/55 text-[11px] tracking-royal uppercase">{t.event}</div>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </Section>
    </>
  );
}
